/* Copyright 2020 The MathWorks, Inc. */

/**
 * This module defines the mapping between the event name as expected by the UIBuilder public API and the actual event
 * emitted by the widget.
 */

define([
        "dojo/_base/lang",
        "MW/statusbar/TypeConstants"
], function (lang, TypeConstants) {

    var hash = {};

    hash[TypeConstants.STATUS_PUSH_BUTTON] = {
        buttonPushed: "click"
    };

    return hash;
});